import React from 'react';
import { Smartphone, Armchair, Gift, ShoppingBag, ArrowUpRight } from 'lucide-react';
import OFFERS from '../config/offers.json';
import './TierDetails.css';

export default function MembershipTierDetails({ tier }) {
  const previewOffers = OFFERS.slice(0, 2);

  return (
    <div className="tp-tier-details" onClick={(e) => e.stopPropagation()}>
      <div className="tp-tier-details__row">
        <Smartphone size={18} strokeWidth={1.5} className="tp-tier-details__icon" />
        <div>
          <p className="label-m tp-tier-details__title">{tier.esimGbPerTrip}GB eSIM data per trip</p>
          <p className="body-s tp-tier-details__body">
            Valid in 190+ countries. No physical SIM, no swapping — scan a QR code and you're online within minutes of landing.
          </p>
        </div>
      </div>

      <div className="tp-tier-details__row">
        <Armchair size={18} strokeWidth={1.5} className="tp-tier-details__icon" />
        <div>
          <p className="label-m tp-tier-details__title">
            {tier.loungeVisitsPerTrip} airport lounge {tier.loungeVisitsPerTrip > 1 ? 'visits' : 'visit'} per trip
          </p>
          <p className="body-s tp-tier-details__body">
            Good at over 10,000 lounges worldwide through our partner Lounge Pass — walk in on any flight, no delay or status required.
          </p>
          <a
            href="https://www.loungepass.com"
            target="_blank"
            rel="noopener noreferrer"
            className="tp-tier-details__link"
          >
            See lounge locations
            <ArrowUpRight size={14} strokeWidth={1.5} />
          </a>
        </div>
      </div>

      {tier.travelKitsPerYear > 0 && (
        <div className="tp-tier-details__row">
          <ShoppingBag size={18} strokeWidth={1.5} className="tp-tier-details__icon" />
          <div>
            <p className="label-m tp-tier-details__title">
              Up to {tier.travelKitsPerYear} Faye travel {tier.travelKitsPerYear > 1 ? 'kits' : 'kit'} a year
            </p>
            <p className="body-s tp-tier-details__body">
              A dark violet Faye tote with an eye mask, earplugs, an inflatable neck pillow, socks, a travel toothbrush, and a branded Faye bag tag.
            </p>
          </div>
        </div>
      )}

      <div className="tp-tier-details__row">
        <Gift size={18} strokeWidth={1.5} className="tp-tier-details__icon" />
        <div>
          <p className="label-m tp-tier-details__title">Exclusive partner offers</p>
          <p className="body-s tp-tier-details__body">
            Discounts on airport transfers, gear, and experiences — deals from brands we've partnered with. A couple of examples:
          </p>
          <ul className="tp-tier-details__offers">
            {previewOffers.map((offer, i) => (
              <li key={i} className="body-s">{offer.headline} — {offer.partner}</li>
            ))}
          </ul>
          <p className="body-s tp-tier-details__note">Full list and codes unlock right after purchase.</p>
        </div>
      </div>
    </div>
  );
}
